export const LogLevel = {
  INFO: 'INFO',
  ERROR: 'ERROR',
  WARN: 'WARN',
  DEBUG: 'DEBUG',
} as const;

type ValueOf<T> = T[keyof T];

export type TLogLevel = ValueOf<typeof LogLevel>;
